export default {
  // Tabs
  saveToNewCase: "Save Canvas to New Case",
  saveToExistingCase: "Save Canvas to Existing Case",

  // Form labels
  caseName: "Case Name",
  caseType: "Case Type",
  caseTypeName: "Case Type Name",
  policeType: "Police Type",
  caseDescription: "Case Description",
  canvasName: "Canvas Name",
  case: "Case",

  // Placeholders
  pleaseEnterCaseName: "Please enter case name (required)",
  pleaseSelectCaseType: "Please select case type (required)",
  pleaseSelectCaseTypeName: "Please select case type name",
  pleaseEnterPoliceType: "Please enter police type",
  pleaseEnterCaseDescription: "Please enter case description",
  pleaseEnterCanvasName: "Please enter canvas name",
  pleaseSelectCase: "Please select case",

  // Buttons
  reset: "Reset",
  saveCanvas: "Save Canvas",

  // Validation messages
  caseNameRequired: "Case name is required",
  caseNameLength: "Length should be 1 to 20 characters",
  caseTypeRequired: "Please select case type",
  caseRequired: "Please select case",
  descriptionLength: "Length should be 1 to 200 characters",
  canvasNameRequired: "Canvas name is required",
  canvasNameLength: "Length should be 1 to 20 characters",

  // Success message
  saveSuccess: "Canvas saved successfully",
};
